import React from "react"
import AboutCard from "../about/AboutCard"
import Hblog from "./Hblog"
import HAbout from "./HAbout"
import Hero from "./hero/Hero"
import Hprice from "./Hprice"
import Testimonal from "./testimonal/Testimonal"
import Popup from "../common/popup/Popup"

const Home = () => {
  return (
    <>
      <Popup />
      <Hero />
      <AboutCard />
      <HAbout />
      <Testimonal />
      {/* <Hblog />
      <Hprice /> */}
    </>
  )
}

export default Home
